<template>
  <div
    :class="[$style.wrapper, { [$style.locked]: locked, [$style.active]: active }]"
    @click="() => { active && $emit('click')}"
  >
    <div :class="$style.icon" :style="{ backgroundImage: `url(${image})`}"></div>
  </div>
</template>
<script>
export default {
  name: 'Achievement',
  props: {
    locked: Boolean,
    image: String,
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" module>
@import './Achievement.scss';
</style>
